<h1 class="page-title">
  <ng-content></ng-content>
</h1>
